"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRightRail = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledRightRail = _styledComponents.default.div.withConfig({
  displayName: "RightRailstyle__StyledRightRail",
  componentId: "sc-bhmyda-0"
})(["box-sizing:border-box;background:white;height:100%;display:flex;flex-direction:column;align-items:center;div{margin-top:29px;:first-child{margin-top:36px;}:nth-child(2){margin-top:88px;}}"]);

exports.StyledRightRail = StyledRightRail;